<div class="row ml-3 mt-2">
  <div class="col">
    <!-- <small>
      <a [routerLink]="['/rental-fleet']" class="text-secondary">Admin Console</a>
      /<a class="text-secondary"> Insights</a>
    </small> -->
    <small *ngIf="accountCategory== 'RENTAL_FLEET'"><a [routerLink]="['/rental-fleet']" class="text-secondary">Admin
        Console</a>
      /<a class="text-secondary"> Insights</a></small>
    <small *ngIf="accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY'"><a [routerLink]="['/commercial-fleet']"
        class="text-secondary">Admin Console</a>
      /<a class="text-secondary"> Insights</a></small>
  </div>
</div>

<div class="row align-items-center justify-content-center home-container">
  <div class="col pl-0 pr-0">
    <div class="row text-center ml-1 mr-1 mt-4">
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/route-analytics.png" alt="accounts" routerLink="/insights" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Route Analytics</span><br>
        <span class="font-nissan-brand-w01-light txt-small">View route performance details</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/vehicle-analytics.png" alt="support"
          routerLink="/insights" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Vehicle Analytics</span><br>
        <span class="font-nissan-brand-w01-light txt-small">View vehicle usage details</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/driver-analytics.png" alt="accounts" routerLink="/insights" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Driver Analytics</span><br>
        <span class="font-nissan-brand-w01-light txt-small">View driver performance details</span>
      </div>
    </div>
  </div>
</div>